import { combineReducers } from 'redux'

import {
  COMPANY_FILTER_CHANGE,
  FETCH_SELECTED_COMPANY_DATA_ASYNC,
} from '../PartnerOptions/constants'

import addMailboxReducer from './Management/AddMailbox/reducer'
import { STATUSES_TOGGLE_ASYNC } from './Management/constants'
import managementReducer from './Management/reducer'
import { STATUS_TOGGLE_ASYNC } from './Management/TableRow/constants'
import tagsFormReducer from './Management/TagsForm/reducer'
import { UPDATE_DATA_REQUEST_ASYNC } from './Management/VipDiscovery/constants'
import vipDiscoveryReducer from './Management/VipDiscovery/reducer'
import menuReducer from './Menu/reducer'
import segmentReducer from './Segments/reducer'
import uploadReducer from './Upload/reducer'
import userReportReducer from './UserReport/reducer'
import { DATA_REQUEST_ASYNC } from './constants'

function mailboxesReducer() {
  const initialState = {
    loader: false,
    isDataLoaded: false,
    data: {},
    error: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case DATA_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true }
      case DATA_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          data: action.payload.data,
          loader: false,
          isDataLoaded: true,
        }
      case UPDATE_DATA_REQUEST_ASYNC.SUCCESS:
      case FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS:
      case COMPANY_FILTER_CHANGE:
        return {
          ...state,
          loader: true,
          error: null,
        }
      case DATA_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error }
      case DATA_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false }
      case STATUSES_TOGGLE_ASYNC.SUCCESS:
        return {
          ...state,
          data: { ...state.data, activeCount: action.payload.data.activeCount },
        }
      case STATUS_TOGGLE_ASYNC.SUCCESS: {
        if (action.payload.data.success) {
          return {
            ...state,
            data: {
              ...state.data,
              activeCount: action.payload.data.active
                ? state.data.activeCount + 1
                : state.data.activeCount - 1,
            },
          }
        }
        return state
      }
      default:
        return state
    }
  }
}

export default function () {
  const initialState = combineReducers({
    self: mailboxesReducer(),
    menu: menuReducer(),
    upload: uploadReducer(),
    management: managementReducer(),
    tagsForm: tagsFormReducer(),
    segments: segmentReducer(),
    userReport: userReportReducer(),
    vipDiscovery: vipDiscoveryReducer(),
    addMailbox: addMailboxReducer(),
  })

  return (state = initialState, action) => {
    switch (action.type) {
      default:
        return state
    }
  }
}
